import { render, staticRenderFns } from "./AllInOneRegistration.vue?vue&type=template&id=484fe80d&scoped=true&"
import script from "./AllInOneRegistration.vue?vue&type=script&lang=js&"
export * from "./AllInOneRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484fe80d",
  null
  
)

export default component.exports